import ReactQuill from 'react-quill';

export const RichTextEditor = ({ value, onChange, onBlur, name }) => (
    <ReactQuill
        theme="snow"
        value={value}
        id={name}
        onChange={onChange}
        onBlur={onBlur}
    />
);